import React from "react";

import styles from "./SubSectionLockedStyles.module.css";
import classnames from "classnames";
import { SectionLocked } from "features/AdminPanel/modules/SectionLocked/SectionLocked";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { RequestVerificationStripe } from "features/Account/modules/SubSectionWrapper/modules/RequestVerificationStripe/RequestVerificationStripe";
import { UpgradePlanChip } from "features/AdminPanel/modules/UpgradePlanChip/UpgradePlanChip";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { getSectionStates } from "features/AdminPanel/modules/utils/AdminPanel.utils";

export const SubSectionLocked = ({ subSection }) => {
  const isDesktop = useDesktopMediaQuery();
  const { handleSectionChange } = useAccountSectionUnlocking();
  const { title = "", key } = subSection || {};
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[key];

  const { isPlanLocked, verificationNotCompleted, disableSwitch } =
    getSectionStates({
      status: subSectionConfig?.status,
    });

  const handleChange = () => {
    const payload = {
      feature_key: key,
      feature_value: !subSectionConfig?.value,
    };
    handleSectionChange({
      payload,
    });
  };

  return (
    <div>
      <div
        className={classnames(
          styles.actionWrapper,
          verificationNotCompleted && styles.columnWrapper
        )}
      >
        {!isDesktop && <div className={styles.spanText}>{title}</div>}
        <div className={classnames(styles.actionInnerWrapper)}>
          <SectionUnlockingSwitch
            value={subSectionConfig?.value}
            onChange={handleChange}
            disabled={disableSwitch}
          />

          {isPlanLocked && <SectionLocked />}
        </div>
        {isDesktop && isPlanLocked && <UpgradePlanChip />}
        {isDesktop && verificationNotCompleted && (
          <RequestVerificationStripe config={subSection} />
        )}
      </div>
      {!isDesktop && isPlanLocked && <UpgradePlanChip />}
      {!isDesktop && verificationNotCompleted && (
        <RequestVerificationStripe config={subSection} />
      )}
    </div>
  );
};
